import { __awaiter } from "tslib";
import { SearchForRetail } from '@/client/api';
import { s4rAuthenticated } from '@/client/utils';
import { parseAreaList } from './area.parsers';
const AREA_PATH = `${SearchForRetail.API_URL}/${SearchForRetail.AREA_PATH}`;
export const getAreaList = (options) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield s4rAuthenticated(Object.assign({ url: AREA_PATH, method: 'GET' }, options));
    return parseAreaList(response.result);
});
export const getNotCopyableConfigs = (fromArea) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield s4rAuthenticated({
        method: 'GET',
        url: `${AREA_PATH}/${fromArea}/config?copyable=false`,
        skipCache: true,
    });
    return response.result;
});
export const copyAllConfigurationsFromAreaToArea = (targetArea, fromArea) => __awaiter(void 0, void 0, void 0, function* () {
    yield s4rAuthenticated({
        method: 'POST',
        skipCache: true,
        url: `${AREA_PATH}/${fromArea}/${SearchForRetail.PROMOTE_PATH}/${targetArea}`,
    });
});
export const duplicate = (fromArea, params) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield s4rAuthenticated({
        method: 'POST',
        skipCache: true,
        url: `${AREA_PATH}/${fromArea}`,
        body: {
            id: fromArea,
            newName: params.name,
        },
    });
    return result.result;
});
export const createArea = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield s4rAuthenticated({
        url: AREA_PATH,
        method: 'POST',
        body: data,
        skipCache: true,
    });
    return response.result;
});
export const updateArea = (areaId, data) => __awaiter(void 0, void 0, void 0, function* () {
    const { result } = yield s4rAuthenticated({
        url: `${AREA_PATH}/${areaId}`,
        method: 'PUT',
        body: data,
        skipCache: true,
    });
    return result;
});
export const deleteArea = (id) => __awaiter(void 0, void 0, void 0, function* () {
    yield s4rAuthenticated({ url: `${AREA_PATH}/${id}`, method: 'DELETE', skipCache: true });
});
export const getAreaById = (areaId) => __awaiter(void 0, void 0, void 0, function* () {
    const { result } = yield s4rAuthenticated({
        url: `${AREA_PATH}/${areaId}`,
        method: 'GET',
        skipCache: true,
    });
    return result;
});
